// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  key: __t.string().primaryKey(),
  stationKey: __t.string().name("station_key"),
  familyKey: __t.string().name("family_key"),
  bestBid: __t.i64().name("best_bid"),
  bidUnits: __t.u32().name("bid_units"),
  bidOrders: __t.u32().name("bid_orders"),
  bestAsk: __t.i64().name("best_ask"),
  askUnits: __t.u32().name("ask_units"),
  askOrders: __t.u32().name("ask_orders"),
  levelsJson: __t.string().name("levels_json"),
  bookRev: __t.u64().name("book_rev"),
  fills: __t.u32(),
  pairs: __t.u32(),
  excluded: __t.u32(),
  medianSov: __t.i64().name("median_sov"),
  vwapX100: __t.i64().name("vwap_x_100"),
  changedAt: __t.timestamp().name("changed_at"),
});
